import { Button, Container, Grid, ThemeProvider, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import { Footer } from './Footer';
import { Header } from './header';
import { theme } from './theme';
LicenseInfo.setLicenseKey('fd90026bed40ed03fe96cd07363e45c4Tz00OTU0NCxFPTE2OTI4MTk2MjQ3MTEsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');

export function Home() {
  return (
    <ThemeProvider theme={theme}>
      <Container sx={{ minHeight: `calc(100vh - 301px)` }}>
        <Grid container spacing={2}>
          <Header label='KinCytE: A Kinase to Cytokine Explorer' home={false} />
          <Grid item xs={12} sm={8}>
            <Typography variant='body1' style={{ paddingBottom: '30px' }}>
              The KinCytE tool connects cytokines, chemokines, and other secreted factors with important kinases and kinase-associated
              proteins. It provides users with information on which kinases and kinase-associated proteins are important for a given
              cytokine or a secreted factor. In addition, it provides users with information on which existing kinase inhibitors would
              inhibit the secretion of a given cytokine. Finally, the tool enables network-centric maps of cytokine-kinase pathways.
            </Typography>
            <Stack gap={3} direction="row">
              <Button variant="outlined" size="large" href="/kincyte/drugs">
                Identify Drugs
              </Button>
              <Button variant="outlined" size="large" href="/kincyte/kinases" >
                Identify Kinases
              </Button>
              <Button variant="outlined" size="large" href="/kincyte/cytokines" >
                Explore Cytokines
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Container >
      <Footer />
    </ThemeProvider>

  );
}

export default Home;
